import { Injectable } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class PreviousUrlService {
  private previousUrl: string | null = null;
  private currentUrl: string | null = null;

  constructor(private router: Router) {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationStart))
      .subscribe((event: NavigationStart) => {
        if (this.currentUrl !== event.url) {
          this.previousUrl = this.currentUrl;
          this.currentUrl = event.url;
        }
      });
  }

  getPreviousUrl(): string | null {
    return this.previousUrl;
  }
}
